import moment from "moment";
import { orderBy } from "lodash";
import draggable from "vuedraggable";

export default {
  name: "KisList",
  props: [
    "items",
    "headers",
    "isLoading",
    "count",
    "isFacilityList",
    "isPersonList"
  ],
  components: { draggable },
  data: () => ({
    filter: { skip: 0, limit: 10, page: 1, itemsPerPage: 10 },
    itemsPerPage: 10,
    tableOptions: { skip: 0, limit: 10, page: 1, itemsPerPage: 10 },
    draggableItems: []
  }),
  mounted() {
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    this.tableOptions.itemsPerPage = this.itemsPerPage ?? 10;
    if (!Array.isArray(this.tableOptions.sortDesc)) {
      this.tableOptions.sortDesc = [];
    }
    this.tableOptions.sortDesc[0] = true;
    if (!Array.isArray(this.tableOptions.sortBy)) {
      this.tableOptions.sortBy = [];
    }
    this.tableOptions.sortBy[0] = "sortOrder";
  },
  watch: {
    items: {
      handler(newItems) {
        this.draggableItems = orderBy(newItems || [], ["sortOrder"], ["asc"]);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async previousPage() {
      const limit = this.filter.limit || this.itemsPerPage;

      const { skip = 0 } = this.filter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage > 1) {
        this.filter.skip = skip - limit;
        this.$emit("getItems", { ...this.filter });
      }
    },
    async nextPage() {
      const limit = this.filter.limit || this.itemsPerPage;

      const totalPages = Math.ceil(this.count / limit);
      const { skip = 0 } = this.filter;
      const currentPage = Math.floor(skip / limit) + 1;

      if (currentPage < totalPages) {
        this.filter.skip = skip + limit;
        this.$emit("getItems", { ...this.filter });
      }
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    updateItemsPerPage(value) {
      this.$emit("setFilterLimit", value);
    },
    triggerFilter(options = {}) {
      const nextItemsPerPage = Number(options.itemsPerPage);
      const resolvedItemsPerPage =
        Number.isFinite(nextItemsPerPage) && nextItemsPerPage > 0
          ? nextItemsPerPage
          : this.itemsPerPage;
      const nextPage = Number(options.page);
      const resolvedPage =
        Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1;
      const skip =
        resolvedPage > 1 ? (resolvedPage - 1) * resolvedItemsPerPage : 0;

      const sortBy = Array.isArray(options.sortBy) ? options.sortBy : [];
      const sortDesc = Array.isArray(options.sortDesc) ? options.sortDesc : [];
      const sort = sortBy[0] || this.filter.sort || "sortOrder";
      const direction = sortDesc[0] ? "desc" : "asc";

      const hasChanged =
        resolvedPage !== this.filter.page ||
        resolvedItemsPerPage !== this.filter.limit ||
        skip !== this.filter.skip ||
        sort !== this.filter.sort ||
        direction !== this.filter.direction;

      if (!hasChanged) return;

      this.itemsPerPage = resolvedItemsPerPage;
      this.filter = {
        ...this.filter,
        limit: resolvedItemsPerPage,
        itemsPerPage: resolvedItemsPerPage,
        page: resolvedPage,
        skip,
        sort,
        direction
      };
      this.$emit("getItems", { ...this.filter });
    },
    async updateSort(direction, item) {
      if (direction === "up") {
        if (item.sortOrder > 0) item.sortOrder -= 1;
      } else item.sortOrder += 1;

      await this.$emit("updateItem", item);
      await this.$emit("getItems", {
        ...this.filter,
        ...this.tableOptions
      });
    },
    async onDragEnd() {
      if (!this.isDragEnabled || !this.isFacilityList) return;
      await this.draggableItems.asyncForEach(async (item, idx) => {
        item.sortOrder = idx;
        await this.$emit("updateItem", item);
      });
    }
  },
  computed: {
    isMobileDevice() {
      return Boolean(
        this.$vuetify &&
          this.$vuetify.breakpoint &&
          this.$vuetify.breakpoint.mobile
      );
    },
    isDragEnabled() {
      return this.isFacilityList && !this.isMobileDevice;
    }
  }
};
